import {ErrorMessages} from 'constants/Errors';
import {Routes} from 'constants/routes';
import {SuccessMessages} from 'constants/Success';

import {AxiosResponse} from 'axios';
import {call, put, select} from 'redux-saga/effects';
import {createNewBrewery} from 'services/breweries';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import Brewery from 'typescript/models/Brewery';

import {createBreweryACS, getBreweriesACS} from '../requestAC';

export function* createBrewery(action: ReturnType<typeof createBreweryACS>) {
  const {dto, navigate} = action.payload;

  const {filters} = yield select((state) => state.breweries);

  try {
    const response: AxiosResponse<ApiData<Brewery>> = yield call(createNewBrewery, dto);
    const newBrewery = response.data.data;

    yield put(getBreweriesACS(filters));
    yield put(setSuccessAC(SuccessMessages.CREATE_BREWERY));
    if (navigate) navigate(`${Routes.BREWERIES_VIEW}/${newBrewery.id}`);
  } catch (error) {
    yield call(handleError, error, ErrorMessages.CREATE_BREWERY);
  }
}
